// extracted by mini-css-extract-plugin
module.exports = {"editProfile":"EditProfile_editProfile__KdY7q","formElementContainer":"EditProfile_formElementContainer__3c9_W","formActions":"EditProfile_formActions__24P54"};